import AuthService from "../api/auth";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { useState } from "react";
import { useAuth } from "../contexts/AuthCtx";

export default function GoogleSignInButton() {
  const authCtx = useAuth();

  const [loading, setLoading] = useState(false);

  const handleSuccess = (e) => {
    console.log("e ::: ", e);
    AuthService.loginGoogle({
      token: e.credential,
    }).then((response) => {
      if (
        response.status &&
        (response.status === 200 || response.status === 201)
      ) {
        let accessTk = response.data.token;
        authCtx.saveAccessToken(accessTk, true);
      } else {
        console.log("Failed to login, status ::: ", response.status);
      }

      setLoading(false);
    });
  };

  const handleFailed = (e) => {
    setLoading(false);
    console.log("Failed to google login ::: ", e);
  };

  return (
    <>
      {loading ? (
        <>
          <h2>Signing you in...</h2>
        </>
      ) : (
        <GoogleLogin
          text={"signin"}
          onSuccess={handleSuccess}
          onError={handleFailed}
          useOneTap={true}
          width={100}
          theme={"filled_blue"}
          shape={"circle"}
          size={"large"}
          type={"standard"}
          cookiePolicy={"single_host_origin"}
          scope={["profile", "email", "https://www.googleapis.com/auth/gmail.readonly"]}
          cancel_on_tap_outside={false}
          click_listener={() => setLoading(true)}
        />
      )}
    </>
  );
}
